module.exports = __webpack_public_path__ + "media/images/redesign-images/sorority-new/customer/customer-14-4be46b24850adf7ae9117a9f9a405095.jpg";